import { ErrorMessage } from '@hookform/error-message';
import ErrorMessageStyle from 'Components/Form/ErrorMessageStyle';
import Label from 'Components/Form/Label';
import { RegisterOptions } from 'react-hook-form';
export interface TextInputProps {
  labelIcon?: React.ReactNode;
  rules?: RegisterOptions;
  disable?: boolean;
  register?: any;
  label?: string;
  errors?: any;
  maxLength?: number;
  placeholder?: string;
  name: string;
  rows?: number;
}
export const TextAreaBasic = ({
  name,
  placeholder = 'Enter...',
  rules,
  label,
  rows = 5,
  labelIcon,
  disable,
  register,
  maxLength,
  errors,
}: TextInputProps) => {
  return (
    <>
      {label && <Label label={label} labelIcon={labelIcon}></Label>}
      <textarea
        className="form__input items-center mt-2"
        placeholder={placeholder}
        {...register(name, rules)}
        defaultValue={''}
        rows={rows}
        disabled={disable}
        maxLength={maxLength}
      />
      {errors && (
        <ErrorMessage
          errors={errors}
          name={name}
          render={({ message }) => <ErrorMessageStyle message={message} />}
        />
      )}
    </>
  );
};
